<script lang="ts" setup></script>

<template>
  <div>
    <ProductDetails />
    <RelatedProduct />
  </div>
</template>

<style scoped></style>
